import { Badge } from '@apovisio/ui';
import type { InvitationStatus, MeetingStatus } from '@apovisio/contracts';

export function MeetingStatusBadge({ status }: { status: MeetingStatus }) {
  if (status === 'LIVE') return <Badge tone="success">En cours</Badge>;
  if (status === 'SCHEDULED') return <Badge tone="info">Programmée</Badge>;
  return <Badge>Terminée</Badge>;
}

export function InvitationStatusBadge({ status }: { status: InvitationStatus }) {
  if (status === 'ACTIVE') return <Badge tone="success">Active</Badge>;
  if (status === 'REVOKED') return <Badge tone="danger">Révoquée</Badge>;
  return <Badge tone="warning">Expirée</Badge>;
}

export function OptionBadges({ chat, screenShare }: { chat: boolean; screenShare: boolean }) {
  return (
    <>
      {chat ? <Badge>Chat</Badge> : null}
      {screenShare ? <Badge>Partage d’écran</Badge> : null}
    </>
  );
}
